import { maestroLightThemeOptions, maestroDarkThemeOptions } from "./maestro";
import { michelinLightThemeOptions, michelinDarkThemeOptions } from "./michelin";
import { lightMichelinThemeOptions } from "./brandCenter";
var DEFAULT_LIGHT_THEME = maestroLightThemeOptions;
var DEFAULT_DARK_THEME = maestroDarkThemeOptions;
export var THEME_DEFINITIONS = {
  light: DEFAULT_LIGHT_THEME,
  dark: DEFAULT_DARK_THEME,
  michelinLight: michelinLightThemeOptions,
  michelinDark: michelinDarkThemeOptions,

  /**
   * @deprecated use `michelinBrandCenter` instead
   */
  michelinLightBC: lightMichelinThemeOptions,
  michelinBrandCenter: lightMichelinThemeOptions,
  maestroLight: maestroLightThemeOptions,
  maestroDark: maestroDarkThemeOptions,
  michelin: undefined
};
export var ACID_THEMES = Object.keys(THEME_DEFINITIONS);
export var isDefinedTheme = function isDefinedTheme(maybeDefinedTheme) {
  return maybeDefinedTheme in THEME_DEFINITIONS;
};